// import React from "react";

// const KpiSuffix = () => {
//   return <div>KpiSuffix</div>;
// };

// export default KpiSuffix;

import React from "react";
import { mergeKpiConfigs } from "../config";
import InfoTitle from "./InfoTitle";

const KpiSuffix = ({ suffix, suffixConfig, option }) => {
  ({ suffixConfig } = mergeKpiConfigs(option, {
    suffixConfig,
  }));
  return (
    <div>
      <InfoTitle title={suffix} {...suffixConfig} />
    </div>
  );
};

export default KpiSuffix;
